import { ReactNode } from "react";

import { createComponentStyleHook } from "capitalrx-components-2.0/lib/tokens";

import { BaseProps } from "../../BaseProps";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";
import { Tooltip } from "../Tooltip";

import tokenStyles from "./styles.module.css";

/** The `Callout` component properties. */
export interface CalloutProps extends BaseProps {
  /** The tooltip text. */
  readonly tooltip: ReactNode;

  /** The tabIndex for the callout trigger element. If not provided, defaults to 0 to make it keyboard-focusable. */
  readonly tabIndex?: number;

  /** The component children. */
  readonly children?: ReactNode;
}

const useResolvedCalloutStyles = createComponentStyleHook<CalloutProps>({
  legacyStyles: () => import("./legacy/styles.module.scss"),
  tokenStyles,
  componentTokens: "callout",
});

/** A component which wraps a set of inline content with a tooltip. */
export const Callout = (props: CalloutProps) => {
  const { tooltip, tabIndex, children } = props;
  const { mode, styles, StyleModeBoundary } = useResolvedCalloutStyles(props);

  const htmlProps = getHtmlPropsFromBaseProps(props, {
    className: [styles.Callout, "callout"],
  });

  return (
    <StyleModeBoundary mode={mode}>
      <Tooltip content={tooltip}>
        {(ref) => (
          <span {...htmlProps} ref={ref} tabIndex={tabIndex ?? 0}>
            {children}
          </span>
        )}
      </Tooltip>
    </StyleModeBoundary>
  );
};
